import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'

// Two-tone color mappings: light track + dark thumb for a11y contrast
const getTwoToneColors = (color: string | undefined): { track: string; thumb: string } => {
    switch (color) {
        case 'primary':
            return { track: 'primary.light', thumb: 'primary.main' }
        case 'warning':
            return { track: 'warning.extraLight', thumb: 'warning.main' }
        case 'success':
        default:
            return { track: 'success.extraLight', thumb: 'success.main' }
    }
}

export const C1SwitchTheme: Components<Theme>['MuiSwitch'] = {
    styleOverrides: {
        root: ({ theme, ownerState }) => {
            const twoTone = getTwoToneColors(ownerState.color)

            return theme.unstable_sx({
                // Dimensions are from "antSwitch" variant: https://v4.mui.com/components/switches/#customized-switches
                // & tweaked to match bounding box of default MUI switch

                '&.MuiSwitch-root': {
                    height: 40,
                },

                '& .MuiSwitch-switchBase': {
                    padding: '2px',
                    margin: '12px',

                    '&:hover': {
                        backgroundColor: 'action.hover',
                    },

                    '&.Mui-focusVisible': {
                        backgroundColor: 'action.focus',
                        '& .MuiSwitch-thumb': {
                            boxShadow: '0 0 0 2px',
                            color: 'primary.main',
                        },
                    },

                    '&.Mui-disabled': {
                        '& .MuiSwitch-thumb': {
                            color: 'grey.300',
                        },
                        '& + .MuiSwitch-track': {
                            opacity: 0.5,
                            backgroundColor: 'grey.200',
                        },
                        '&.Mui-checked': {
                            '& .MuiSwitch-thumb': {
                                color: twoTone.thumb,
                                opacity: 0.5,
                            },
                            '& + .MuiSwitch-track': {
                                opacity: 0.5,
                                backgroundColor: twoTone.track,
                            },
                        },
                    },

                    '&.Mui-checked': {
                        transform: 'translateX(18px)',

                        '& .MuiSwitch-thumb': {
                            color: twoTone.thumb,
                        },

                        '&:hover': {
                            backgroundColor: 'action.hover',
                        },

                        '&.Mui-focusVisible': {
                            backgroundColor: 'action.focus',
                            '& .MuiSwitch-thumb': {
                                boxShadow: '0 0 0 2px',
                                color: twoTone.thumb,
                            },
                        },

                        '& + .MuiSwitch-track': {
                            opacity: 1,
                            backgroundColor: twoTone.track,
                        },
                    },
                },

                '& .MuiSwitch-thumb': {
                    boxShadow: 'none',
                    width: '12px',
                    height: '12px',
                    borderRadius: '6px',
                },

                '& .MuiSwitch-track': {
                    borderRadius: '8px',
                    opacity: 1,
                    boxSizing: 'border-box',
                    backgroundColor: 'grey.300',
                },
            })
        },
    },
}
